import script from "./FollowUpModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FollowUpModal.vue?vue&type=script&setup=true&lang=ts"

import "./FollowUpModal.vue?vue&type=style&index=0&id=4384c090&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4384c090"]])

export default __exports__